<template>
  <modal v-if="show" class="agreement-modal solid">
    <loader v-if="loading"></loader>
    <div class="agreement-modal-content" v-else-if="content" v-html="content">
    </div>
    <h3 v-else class="agreement-modal-error">The agreement is not available</h3>
  </modal>  
</template>

<script>
  import Loader from "../../common/loader.vue";
  import Modal from "../../common/modal.vue";

  export default {
    components: {
      Loader,
      Modal,
    },
    props: [
      'loading',
      'show',
      'content',
    ],
    created() {
        this.$on('closeModal', () => {
          this.$parent.$emit('closeModal');
        });
    },
  }
</script>

<style lang="scss">
  .agreement-modal {
    &-error {
      position: relative;
      top: 40%;
    }
    &-content {
      text-align: left;
      padding: 50px 20px 0;
      overflow-y: scroll;
      height: 100%;

      > :last-child{
        margin-bottom: 120px;
      }
      p {
        margin-block-start: 1em;
        margin-block-end: 1em;
        word-break: break-word
      }
      ol, ul {
        margin-block-start: 1em;
        margin-block-end: 1em;
        padding-inline-start: 20px;
      }
    }
  }
</style>